import {
    BaseFeatureArgs,
    FixedFilterGenerator,
    SkipOrArgs,
} from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useCollections, UseCollectionsArgs } from './useCollections';
import { useHeadlessQuery } from '@common/hooks';

export interface UseCollectionAssetIdsArgs extends BaseFeatureArgs {
    collectionId: string;
}

const collectionAssetIdsFilterGenerator: FixedFilterGenerator<
    UseCollectionAssetIdsArgs
> = (args) => {
    return [`parentId:${args.collectionId}`];
};

export const useCollectionAssetIds = (
    args: SkipOrArgs<UseCollectionAssetIdsArgs>,
) => {
    const baseArgs: SkipOrArgs<UseCollectionsArgs> = useMemo(() => {
        if (args === skipToken) return skipToken;
        return {
            ...args,
            overrideFilterGenerator: collectionAssetIdsFilterGenerator,
        } as UseCollectionsArgs;
    }, [args]);

    const { itemCount, isFetching: isCountFetching } = useHeadlessQuery(
        useCollections,
        { pageSize: 0 },
        baseArgs,
    );

    const fetchAllArgs = useMemo(() => {
        if (baseArgs === skipToken || isCountFetching || !itemCount)
            return skipToken;
        return baseArgs;
    }, [baseArgs, isCountFetching, itemCount]);

    return useHeadlessQuery(useCollections, {}, fetchAllArgs, {
        paramsOverride: { pageSize: itemCount },
    });
};
